export const zoningAllowanceDictionary = {
    ZoningCodeId: 'Zoning Code',
    ZoningRegulationName: 'Zoning Regulation Name',
    ZoningRegulationLink: 'Zoning Regulation Link',
    ZoneCombinationName: 'Zone Name',
    ZoneId: 'Zone',
    SubZoneId: 'Sub-Zone',
    ZoneTypeId: 'Type',
    BuildingTypologyId: 'Building Type',
    FrontageOverrides: 'Frontage Overrides JSON',
    IsDefaultBuildingTypologyFromOverlay: '*Is Default Building Typology from Overlay',
    StreetParking: 'On-Street Parking Available',
    StreetParkingValue: 'On-Street Parking Type'
};
